<template>
  <transition name="modal">
    <div
      class="modal-mask flex justify-center items-center "
      @click="close"
      v-show="show"
    >
      <div
        class="modal-container bg-pink-100 rounded-12 w-3/4 mx-auto my-auto p-0 md:p-2 overflow-y-scroll max-h-screen"
        @click.stop
      >
        <slot></slot>
           <button class="close text-2xl md:text-3xl md:mt-2 mr-0" @click="close">&times;</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  props: ["show"],
  methods: {
    close: function() {
      this.$emit("close");
    },
  },
  mounted: function() {
    document.addEventListener("keydown", (e) => {
      if (this.show && e.keyCode == 27) {
        this.close();
      }
    });
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.close{
  position: absolute;
  top:0;
  right:0;
  padding:0 1rem;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.85);
  transition: opacity 0.3s ease;
}

.modal-container {
  position: relative;
  border-radius: 12px;
  transition: all 0.3s ease;

}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  margin: 20px 0;
}

.text-right {
  text-align: right;
}

.form-label {
  display: block;
  margin-bottom: 1em;
}

.form-label > .form-control {
  margin-top: 0.5em;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: 1px solid #ddd;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
